import React from "react";
import {message } from "antd";
var CryptoJS = require("crypto-js");

export const encryptUsingAES256 = (encString,hashKey) => {
    const key = CryptoJS.enc.Utf8.parse(hashKey);
    const iv = CryptoJS.enc.Utf8.parse(hashKey);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse((encString)), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();

    return encrypted;
}

export const decryptUsingAES256 = (decString,hashKey) => {
        
    const key = CryptoJS.enc.Utf8.parse(hashKey);
    const iv = CryptoJS.enc.Utf8.parse(hashKey);    

    var decrypted = CryptoJS.AES.decrypt(decString, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export const validatePassword = (value) => {

  const uppercaseRegExp   = /(?=.*?[A-Z])/;
  const lowercaseRegExp   = /(?=.*?[a-z])/;
  const specialCharRegExp = /(?=.*?[#?!@$%^&*-.])/;
  const minLengthRegExp   = /.{7,}/;

  const minLengthPassword =   minLengthRegExp.test(value);
  const uppercasePassword =   uppercaseRegExp.test(value);
  const lowercasePassword =   lowercaseRegExp.test(value);
  const specialCharPassword = specialCharRegExp.test(value);

  var errorMessage = "";
  
  if(!minLengthPassword){
    errorMessage  += "Şifreniz 6 karakterden uzun olmalıdır.";
  }

  if(!uppercasePassword || !lowercasePassword){
    errorMessage  += "Şifreniz büyük ve küçük harf içermelidir.";
  }
 
  if(!specialCharPassword){
    errorMessage  += "Şifreniz noktalama işaretleri içermelidir.";
  }

  return errorMessage;

}

export const successMessage = (msg) => {
    message.success(msg);
}

export const errorMessage = (msg) => {
    message.error(msg);
}

export const isNullOrEmptyOrUndefined = (val) => {
    return val == null || val == '' || val == undefined 
}


const TC = [
    {
      id: 'tc1',
      label: 'TC1',
    },
    {
      id: 'tc2',
      label: 'TC2',
    },
    {
      id: 'tc3',
      label: 'TC3',
    }
  ];
  
  const FRAGMENTS = [
    {
      id: 'frag1',
      label: 'The Connected',
    },
    {
      id: 'frag2',
      label: 'The Cherry picker',
    }
  ];
  
export const TC_IDS = TC.map(({ id }) => id);
export const FRAGMENTS_IDS = FRAGMENTS.map(({ id }) => id);